import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { CubicMeter, CubicCentiMeter, CubicFeet } from "./volume";
import { Gram, Slug, PoundLb } from "./mass";
// Density
export var KilogramPerCubicMeter = UnitDivide.massByVolume("KilogramPerCubicMeter", BaseUnits.Kilogram, CubicMeter);
export var GramPerCubicCentiMeter = UnitDivide.massByVolume("GramPerCubicCentiMeter", Gram, CubicCentiMeter);
export var SlugPerCubicFeet = UnitDivide.massByVolume("SlugPerCubicFeet", Slug, CubicFeet);
export var PoundPerCubicFoot = UnitDivide.massByVolume("PoundPerCubicFoot", PoundLb, CubicFeet);
//# sourceMappingURL=density.js.map